import { useEffect, useState } from 'react';
import StoreCustomerService from '../services/storeCustomerService';
import requestDeduplicator from '../utils/requestDeduplicator';
import { toCustomerDropdownItem } from '../utils/customerDropdownUtils';

const dropdownCache = new Map();
const getRequestKey = (storeId) => `store-customer-dropdown-${storeId}`;

const useStoreCustomerDropdown = (storeId, enabled = true) => {
  const [customers, setCustomers] = useState(() => (
    storeId && enabled ? (dropdownCache.get(storeId) || []) : []
  ));
  const [loading, setLoading] = useState(() => (
    Boolean(storeId && enabled && !dropdownCache.has(storeId))
  ));

  useEffect(() => {
    if (!storeId || !enabled) {
      setCustomers(storeId ? (dropdownCache.get(storeId) || []) : []);
      setLoading(false);
      return undefined;
    }

    const cached = dropdownCache.get(storeId);
    if (cached) {
      setCustomers(cached);
    }

    let cancelled = false;
    if (!cached) {
      setLoading(true);
    }

    requestDeduplicator
      .deduplicate(getRequestKey(storeId), () => (
        StoreCustomerService.getStoreCustomerDropdown(storeId)
      ))
      .then((result) => {
        const items = (Array.isArray(result) ? result : [])
          .map(toCustomerDropdownItem)
          .filter(Boolean);
        dropdownCache.set(storeId, items);
        if (!cancelled) {
          setCustomers(items);
        }
      })
      .catch((error) => {
        console.error('Failed to load customer dropdown:', error);
        if (!cancelled && !cached) {
          setCustomers([]);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [storeId, enabled]);

  return { customers, loading };
};

export const clearStoreCustomerDropdownCache = () => {
  dropdownCache.clear();
};

export default useStoreCustomerDropdown;
